export const THINGS_PAGE_NS = 'pages/ThingsPage';

export const i18n = {
  en: {
    buttons: {
      builder: 'Builder',
    },
    noItems: 'No items',
    empty: {
      title: 'You have no assets yet',
      message:
        'Create your first asset and invite other participants in a completely transparent way.',
    },
  },
};
